import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FuseAlertModule, FuseCardModule} from 'fuseui';

import {AuthSignInComponent} from './sign-in.component';
import {authSignInRoutes} from './sign-in.routing';
import {SharedModule} from "../../../../../../apps/fuse/src/app/shared/shared.module";
import {TranslateModule} from "@ngx-translate/core";
import { MatDivider } from '@angular/material/divider';

@NgModule({
    declarations: [
        AuthSignInComponent
    ],
  imports: [
    RouterModule.forChild(authSignInRoutes),
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    FuseCardModule,
    FuseAlertModule,
    SharedModule,
    TranslateModule,
    MatDivider
  ]
})
export class AuthSignInModule
{
}
